import { VOICE_PAGE_WRAPPER_ID } from '../../common/constants/subscriptionConstants.js';
import { OfferType } from '../../common/enums.js';
import { ProductOfferingsCardsByOfferTypeCoCo } from '../OrderSubscriptionSelection/ProductOfferingsCardsByOfferTypeCoCo.js';
import { PublicMobileVoiceBreadcrumbs } from './PublicMobileVoiceBreadcrumbs.js';
import { PublicMobileVoiceFeatureHighlights } from './PublicMobileVoiceFeatureHighlights';
import { PublicMobileVoiceHeader } from './PublicMobileVoiceHeader.js';
import { PublicMobileVoiceSubscriptionsAdditionalComponents } from './PublicMobileVoiceSubscriptionsAdditionalComponents';

import './PublicMobileVoiceSubscriptions.scss';

export const PublicMobileVoiceProductOfferingsCoCo = () => {
  return (
    <section className="of-public-mobile-voice-subscriptions of-public-page" id={VOICE_PAGE_WRAPPER_ID}>
      <PublicMobileVoiceBreadcrumbs />
      <PublicMobileVoiceHeader />
      <PublicMobileVoiceFeatureHighlights />
      <ProductOfferingsCardsByOfferTypeCoCo offerType={OfferType.VOICE} publicPages />
      <PublicMobileVoiceSubscriptionsAdditionalComponents />
    </section>
  );
};
